module.exports = __webpack_public_path__ + "img/upload.463a7636.png";